import React, { useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { footerPages } from '../data/footerPages';

export default function InfoPage({ pageKey }) {
  const page = footerPages[pageKey];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageKey]);

  if (!page) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="min-h-screen">
      <section className="relative overflow-hidden bg-black text-white">
        <div
          className="absolute inset-0 opacity-20"
          style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, #cc7c66 0%, transparent 58%)' }}
        />
        <div className="relative mx-auto max-w-7xl px-6 py-16 lg:px-8 lg:py-20">
          <p className="mb-4 text-xs uppercase tracking-[0.35em] text-[#cc7c66]">{page.eyebrow}</p>
          <h1 className="max-w-3xl font-display text-4xl font-light leading-tight sm:text-5xl lg:text-6xl">
            {page.title}
          </h1>
          <p className="mt-5 max-w-2xl text-sm font-light leading-relaxed text-gray-300 sm:text-base">
            {page.intro}
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <div className="space-y-12">
            {page.sections.map((section) => (
              <article key={section.heading} className="border-b border-gray-100 pb-10 last:border-0">
                <h2 className="mb-4 font-display text-2xl font-light text-black sm:text-3xl">
                  {section.heading}
                </h2>
                <div className="space-y-4">
                  {section.body?.map((paragraph) => (
                    <p key={paragraph.slice(0, 32)} className="text-sm font-light leading-relaxed text-gray-600">
                      {paragraph}
                    </p>
                  ))}
                  {section.items && (
                    <ul className="space-y-2 pl-1">
                      {section.items.map((item) => (
                        <li key={item} className="flex gap-2 text-sm font-light leading-relaxed text-gray-600">
                          <span className="text-[#cc7c66]">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </article>
            ))}
          </div>

          <div className="mt-14 rounded-2xl border border-gray-200 bg-[#fdf8f6] p-6 sm:p-8">
            <p className="mb-2 text-xs uppercase tracking-[0.3em] text-gray-400">Need help?</p>
            <p className="mb-5 text-sm font-light leading-relaxed text-gray-600">
              Our team is happy to answer questions about orders, products, or policies.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 border border-black px-6 py-3 text-xs uppercase tracking-[0.2em] transition-colors hover:bg-black hover:text-white"
              >
                Contact Us <ArrowRight size={14} />
              </Link>
              <a
                href="mailto:hello@metameni.com"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gray-500 transition-colors hover:text-black"
              >
                hello@metameni.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
